import { render, staticRenderFns } from "./XifresMensuals.vue?vue&type=template&id=5d144ea7&"
import script from "./XifresMensuals.vue?vue&type=script&lang=js&"
export * from "./XifresMensuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports